import React, { Component } from 'react';
import { ThemeContext } from '../../../context/theme.context';
import '../style.css';
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  ILoadedEventArgs,
  ScrollBar,
  Zoom,
  LineSeries,
} from '@syncfusion/ej2-react-charts';
import { getTradeGraph } from '../../../services/KPIsServices/KPIsServices';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import Scheduler from '../../../components/GlobalScheduler';
import Loader from 'react-spinners/PulseLoader';
import { BiRefresh } from 'react-icons/bi';
interface IProps {}
interface IState {
  showSpinner: boolean;
  graph1Data: Array<any>;
  graph11DataShift: Array<any>;
  graph11DataException: Array<any>;
  graph2Data: Array<any>;
  graph3Data: Array<any>;
}
export default class TradeCapacity extends Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private graph1Trade: Array<any> = [];
  private graph2Trade: Array<any> = [];
  private graph3Trade: Array<any> = [];
  private graph1Tickets: Array<any> = [];
  private graph2Tickets: Array<any> = [];
  private graph3Tickets: Array<any> = [];
  private grap1Obj: ChartComponent;
  private grap2Obj: ChartComponent;
  private grap3Obj: ChartComponent;
  private listObj: ListViewComponent;
  constructor(props: IProps) {
    super(props);
    this.state = {
      showSpinner: false,
      graph1Data: [],
      graph2Data: [],
      graph11DataException: [],
      graph3Data: [],
      graph11DataShift: [],
    };
    this.grap1Obj = new ChartComponent(props);
    this.grap2Obj = new ChartComponent(props);
    this.grap3Obj = new ChartComponent(props);
    this.listObj = new ListViewComponent(props);
  }
  private baseColor = 'e36927';
  private colors = [
    '#7a42db',
    '#db6b16',
    '#db3016',
    '#30ed13',
    '#696969',
    '#22799c',
    '#db6b16',
    '#81a391',
    '#8216db',
    '#8e18c9',
    '#f2eeb8',
    '#00b6ff',
    '#2a1140',
    '#d736e3',
    '#d1c40f',
    '#a971ad',
    '#6c5f73',
    '#e6e3e8',
    '#f097b0',
    '#73eb89',
  ];
  generateColor(color: string, index: number) {
    return this.colors[index];
  }
  componentDidMount() {
    this.getTradesGraph(Scheduler.AllFilterDAta);
  }
  designData1(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      const foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.team_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.team_code,
            color: this.generateColor(this.baseColor, counter),
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return (
          elin.trade_code === element.trade_code ||
          (elin.value === 'Exception' && element.type === 'Exception')
        );
      });

      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.team_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          trade_code: element.trade_code,
          team_code: element.team_code,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  }
  designData2(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.trade_code === element.trade_code;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          trade_code: element.trade_code,
          element_alias: element.element_alias,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  }
  designData3(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      const foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.trade_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });

      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.trade_code,
            color: this.generateColor(this.baseColor, counter),
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.dayName === element.dayName;
      });
      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.trade_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          dayName: element.dayName,
          trade_code: element.trade_code,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  }
  async getTradesGraph(query: string) {
    this.graph1Trade = [];
    this.graph2Trade = [];
    this.graph3Trade = [];
    this.graph1Tickets = [];
    this.graph2Tickets = [];
    this.graph3Tickets = [];
    await getTradeGraph(query)
      .then((el) => {
        this.designData1(el.data.dataG1, this.graph1Tickets, this.graph1Trade);
        this.designData2(el.data.dataG2, this.graph2Tickets, this.graph2Trade);
        this.designData3(el.data.dataG3, this.graph3Tickets, this.graph3Trade);

        const theShift: Array<any> = [];
        const theException: Array<any> = [];
        el.data.dataG4.map((el: any) => {
          if (el.roster_type === 'Shift') {
            theShift.push({
              trade_code: el.trade_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          } else {
            theException.push({
              trade_code: el.trade_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          }
        });
        this.setState({
          graph11DataShift: theShift,
          graph11DataException: theException,
          graph1Data: this.graph1Trade,
          graph2Data: this.graph2Trade,
          graph3Data: this.graph3Trade,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  generateInitialFilter = () => {
    let date = new Date();
    const startDate = date.getMonth() + 1 + '/' + 1 + '/' + date.getFullYear();
    const endDate =
      date.getMonth() +
      1 +
      '/' +
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() +
      '/' +
      date.getFullYear();
    var alias = '';
    alias = alias.replace(/.$/, '');
    const asignments: any = [];
    return `'${startDate}'$'${endDate}'$${asignments}$${alias}`;
  };
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (this.state != prevState) {
      return;
    }
    if (this.context.isDataChangeKpiTrade) {
      this.getTradesGraph(Scheduler.AllFilterDAta);
      this.context.setDataChangeKpiTrade(false);
    }
  }
  public onChartLoad(args: ILoadedEventArgs): void {}

  public load(args: ILoadedEventArgs): void {}
  renderTemplateListElement = (el: any) => {
    return (
      <div className='eachPiece'>
        <div className='line'></div>
        <div className='eachTexts'>
          <span className='eachTeamText'>
            {el.trade_code === '' ? 'NO TRADE' : el.trade_code}
          </span>
          <span className='eachTeamCountText'>{Math.abs(el.Y)}</span>
        </div>
      </div>
    );
  };
  render() {
    return (
      <>
        {this.state.showSpinner ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '300px',
            }}
          >
            <Loader color='#A020F0' />
          </div>
        ) : (
          <div className='wrapper'>
            <div className='main-chart-content'>
              <BiRefresh
                size={23}
                onClick={async () => {
                  this.setState({ showSpinner: true });
                  await this.getTradesGraph(Scheduler.AllFilterDAta);
                  this.setState({ showSpinner: false });
                }}
              />
              <div className='chart1' style={{ width: '28%' }}>
                <div className='left-component-first'>
                  <span>
                    <b># of Hours By Team</b>
                  </span>
                </div>
                <div>
                  <ChartComponent
                    id='tradecharts'
                    style={{ textAlign: 'center' }}
                    ref={(el) => {
                      this.grap1Obj = el as ChartComponent;
                    }}
                    primaryXAxis={{
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },

                      lineStyle: { width: 0 },
                      labelIntersectAction: 'Rotate45',
                      labelStyle: {
                        size: '8px',
                      },
                      valueType: 'Category',
                    }}
                    width={'100%'}
                    primaryYAxis={{
                      lineStyle: { width: 0 },
                      majorTickLines: { width: 1 },
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 1 },
                      minorTickLines: { width: 1 },
                      labelFormat: '{value}',
                      labelStyle: {
                        size: '8px',
                      },
                    }}
                    chartArea={{ border: { width: 0 } }}
                    load={this.load.bind(this)}
                    loaded={this.onChartLoad.bind(this)}
                    tooltip={{ enable: true }}
                    height={'190px'}
                    background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    legendSettings={{
                      textStyle: {
                        color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Category,
                        Legend,
                        Tooltip,
                        LineSeries,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {this.graph1Tickets.map((el: any, index: number) => {
                        if (el.type === 'Exception') {
                          return (
                            <SeriesDirective
                              zOrder={1000000}
                              key={Math.random()}
                              dataSource={this.state.graph1Data}
                              xName='trade_code'
                              yName={`y${index}`}
                              animation={{ enable: true }}
                              name={el.value}
                              type='Line'
                              fill={el.color}
                              marker={{ visible: true, width: 10, height: 10 }}
                            ></SeriesDirective>
                          );
                        } else {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={this.state.graph1Data}
                              xName='trade_code'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                              cornerRadius={{
                                topLeft: 0,
                                topRight: 0,
                              }}
                            ></SeriesDirective>
                          );
                        }
                      })}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                </div>
                <div className='left-component-fourr'></div>
              </div>
              <div className='chart2' style={{ width: '28%' }}>
                <div className='blanc-text'>
                  <span>
                    <b># of Hours by Exception Element</b>
                  </span>
                </div>
                <ChartComponent
                  id='tradecharts2'
                  style={{ textAlign: 'center' }}
                  ref={(el) => {
                    this.grap2Obj = el as ChartComponent;
                  }}
                  primaryXAxis={{
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 0 },
                    majorTickLines: { width: 0 },
                    minorTickLines: { width: 0 },
                    interval: 1,
                    lineStyle: { width: 0 },
                    labelIntersectAction: 'Rotate45',
                    labelStyle: {
                      size: '8px',
                    },
                    valueType: 'Category',
                  }}
                  primaryYAxis={{
                    lineStyle: { width: 0 },
                    majorTickLines: { width: 1 },
                    majorGridLines: { width: 0 },
                    minorGridLines: { width: 1 },
                    minorTickLines: { width: 1 },
                    labelFormat: '{value}',
                    labelStyle: {
                      size: '8px',
                    },
                  }}
                  width={'100%'}
                  chartArea={{ border: { width: 0 } }}
                  load={this.load.bind(this)}
                  loaded={this.onChartLoad.bind(this)}
                  tooltip={{ enable: true }}
                  height={'190px'}
                  background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                  legendSettings={{
                    textStyle: {
                      color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                      size: '8px',
                    },
                    position: 'Top',
                  }}
                >
                  <Inject
                    services={[StackingColumnSeries, Category, Legend, Tooltip]}
                  />
                  <SeriesCollectionDirective>
                    {this.graph2Tickets.map((el: any, index: number) => {
                      return (
                        <SeriesDirective
                          key={Math.random()}
                          dataSource={this.state.graph2Data}
                          xName='trade_code'
                          yName={`y${index}`}
                          name={el.value}
                          type='StackingColumn'
                          fill={el.color}
                        ></SeriesDirective>
                      );
                    })}
                  </SeriesCollectionDirective>
                </ChartComponent>
              </div>
              <div className='chart3' style={{ width: '28%' }}>
                <div>
                  <span>
                    <b># of Hours by Exception Element</b>
                  </span>
                </div>
                <div>
                  <ChartComponent
                    id='tradecharts3'
                    style={{ textAlign: 'center' }}
                    ref={(el) => {
                      this.grap3Obj = el as ChartComponent;
                    }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      labelStyle: {
                        size: '8px',
                      },
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    primaryYAxis={{
                      rangePadding: 'None',

                      majorTickLines: { width: 1 },
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 1 },
                      minorTickLines: { width: 1 },
                      lineStyle: {
                        width: 0,
                      },
                      labelStyle: {
                        size: '8px',
                      },
                    }}
                    width={'100%'}
                    chartArea={{ border: { width: 0 } }}
                    load={this.load.bind(this)}
                    loaded={this.onChartLoad.bind(this)}
                    tooltip={{
                      enable: true,
                    }}
                    height={'190px'}
                    background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    legendSettings={{
                      textStyle: {
                        color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                    zoomSettings={{
                      mode: 'XY',
                      enableDeferredZooming: true,
                      enableMouseWheelZooming: true,
                      enablePan: true,
                      enableScrollbar: true,
                      enablePinchZooming: true,
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        LineSeries,
                        Legend,
                        Tooltip,
                        Category,
                        ScrollBar,
                        Zoom,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {this.graph3Tickets.map((el: any, index: number) => {
                        if (el.type === 'Exception') {
                          return (
                            <SeriesDirective
                              zOrder={1000000}
                              key={Math.random()}
                              dataSource={this.state.graph3Data}
                              xName='dayName'
                              yName={`y${index}`}
                              animation={{ enable: true }}
                              name={el.value}
                              type='Line'
                              fill={el.color}
                              marker={{ visible: true, width: 10, height: 10 }}
                            ></SeriesDirective>
                          );
                        } else {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={this.state.graph3Data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                              cornerRadius={{
                                topLeft: 0,
                                topRight: 0,
                              }}
                            ></SeriesDirective>
                          );
                        }
                      })}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                </div>
              </div>
              <div className='detail-content'>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  {this.state.graph11DataShift.length > 0 ? (
                    <div style={{ flexDirection: 'column', display: 'flex' }}>
                      <span>Shift</span>
                      <ListViewComponent
                        ref={(e) => {
                          this.listObj = e as ListViewComponent;
                        }}
                        className={'hiddenListElement'}
                        id='sample-list-flat'
                        dataSource={this.state.graph11DataShift}
                        template={this.renderTemplateListElement.bind(this)}
                        cssClass='e-list-template'
                        animation={{
                          effect: 'SlideLeft',
                          duration: 500,
                          easing: 'ease',
                        }}
                        height={'200px'}
                      ></ListViewComponent>
                    </div>
                  ) : null}
                  {this.state.graph11DataException.length > 0 ? (
                    <div style={{ flexDirection: 'column', display: 'flex' }}>
                      <span>Exception</span>
                      <ListViewComponent
                        ref={(e) => {
                          this.listObj = e as ListViewComponent;
                        }}
                        className={'hiddenListElement'}
                        id='sample-list-flat'
                        dataSource={this.state.graph11DataException}
                        template={this.renderTemplateListElement.bind(this)}
                        cssClass='e-list-template'
                        animation={{
                          effect: 'SlideLeft',
                          duration: 500,
                          easing: 'ease',
                        }}
                        height={'200px'}
                      ></ListViewComponent>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
